export default {
  edit_note: 'Muokkaa huomautusta',
  add_note: 'Lisää huomautus ',
  update: 'Päivitä tuote',
  feedback: {
    item_sold_out_one: 'Valitettavasti {{items}} ei ole juuri nyt saatavilla.',
    item_sold_out_other: 'Valitettavasti {{items}} ei ole juuri nyt saatavilla.',
    item_unavailable:
      'Tämä tuote on saatavilla vain klo {{schedule}}. Vaihda tilauksen aikaa tai poista tuote tilataksesi.',
  },
  buttons: {
    update: 'Päivitä',
  },
};
